import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';
import { ViewResultsButton } from './ViewResultsButton';
import { SaveActionMenu } from './SaveActionMenu';
import { UpdateActionMenu } from './UpdateActionMenu';
import { UpdateButton } from './UpdateButton';
import { useTranslation } from '../../hooks';
import { useListDetailsContext } from '../../contexts/listDetails';
import {
  StyledButtonGroup,
  StyledKey,
  StyledKeyValueGroup,
  StyledSidePanel,
  StyledSidePanelSection,
} from './Styled';
import { PAGE_VARIATIONS } from '../../constants';
import { SegmentationUsersCount } from '../SegmentationUsersCount';

export const testIds = {
  panel: 'segmentation-sp',
  countProject: 'segmentation-sp-project-user-count',
  countSegment: 'segmentation-sp-segment-user-count',
};

export const SidePanel = () => {
  const { t } = useTranslation();
  const { pageVariation } = useListDetailsContext();
  const isStaticList = pageVariation === PAGE_VARIATIONS.STATIC;
  const isDynamicList = pageVariation === PAGE_VARIATIONS.DYNAMIC;
  const navBarHeight = useNavBarHeight();

  return (
    // Ideally we do not pass in props to styled components but constrained by useNavBarHeight util
    <StyledSidePanel data-test={testIds.panel} navBarHeight={navBarHeight}>
      <StyledSidePanelSection>
        <StyledKeyValueGroup>
          <SegmentationUsersCount dataTest={testIds.countSegment} />
          <StyledKey>{t('sidePanel.usersInSegment')}</StyledKey>
        </StyledKeyValueGroup>
        <StyledButtonGroup>
          <ViewResultsButton />
          {isStaticList && <UpdateActionMenu />}
          {isDynamicList && <UpdateButton />}
          <SaveActionMenu />
        </StyledButtonGroup>
      </StyledSidePanelSection>
    </StyledSidePanel>
  );
};
